import { useEffect } from "react";
import PropertyInput from "./input-property.tsx";
import { useStore } from "../../state/state.ts";
import { MainPropertyKey } from "../../state/properties.ts";

export function InputVerbrauchsEinheitCurrent() {
   const heizung = useStore((state)=>state.heizung);

   const verbrauch = ()=>{
      switch (heizung) {
         case "heating_system_current_5":
              return<></>;
         case "heating_system_current_0":
         case "heating_system_current_8":
         case "heating_system_current_10":
            return <PropertyInput type="verbrauchseinheit_oel_current"/>;
         case "heating_system_current_1":
         case "heating_system_current_7":
         case "heating_system_current_9":
            return <PropertyInput type="verbrauchseinheit_gas_current"/>;
         case "heating_system_current_2":
            return <PropertyInput type="verbrauchseinheit_holz_current"/>;
         case "heating_system_current_3":
         case "heating_system_current_4":
         case "heating_system_current_6":
         default:
            return <PropertyInput type="verbrauchseinheit_andere_current"/>

      }
   }

   return <>{ verbrauch() }</>;
}